import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './Manage_User.css';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import Pagination from './Pagination.js';
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Finance_Fuel_Reports() {
    const token = localStorage.getItem("authToken") || null;
    const navigate = useNavigate();
    const location = useLocation();
    const [EmpCode, setEmpCode] = useState('');
    const [fuelFormList, setFuelFormList] = useState([]);
    const [items, setItems] = useState([]);
    const [RptMgr, setRptMgr] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
     const [financeStatusFilter, setFinanceStatusFilter] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);
     const [startDate, setStartDate] = useState(null);  // For date picker
            const [endDate, setEndDate] = useState(null);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortOrder, setSortOrder] = useState("asc");
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
            const fetchProfileData = async () => {
                try {
                    const token = localStorage.getItem('authToken');
                    const response = await fetch(`${API_BASE_URL}profile`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
    
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
    
                    const result = await response.json();
    
                    if (result.status) {
                        setEmpCode(result.profile.emp_code || '');
                        setRptMgr(result.profile.report_mngr || '');
                    } else {
                        setResponseMessage('Error: ' + result.message);
                    }
                } catch (error) {
                    console.error('Fetch error:', error);
                    setResponseMessage('Error: ' + error.message);
                }
            };
    
            fetchProfileData();
        }, []);
    useEffect(() => {
        const fetchFuelFormList = async (EmpCode) => {
            try {
                if (!token || !EmpCode) return;
                const response = await fetch(`${API_BASE_URL}getFuelFormfm?accounts_mngr=${encodeURIComponent(EmpCode)}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'AUTHORIZATION': `Bearer ${token}`
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('API Response:', data);

                // Access the 'data' array inside the response

                setFuelFormList(Array.isArray(data.data) ? data.data : []);
                setItems(Array.isArray(data.data) ? data.data : []);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching fuel forms:', error);
                setFuelFormList([]);
            }
        };

        if (EmpCode) {
            fetchFuelFormList(EmpCode);
        }
    }, [EmpCode, navigate]);

    useEffect(() => {
            const savedFilter = localStorage.getItem('financeStatusFilter');
            if (savedFilter) setFinanceStatusFilter(savedFilter);
        }, []);

    useEffect(() => {
            if (!Array.isArray(items)) {
                setFilteredItems([]);
                return;
            }
        
            const filtered = items.filter(item => {
                const codeMatch = item.emp_code ? item.emp_code.toLowerCase().includes(searchQuery.toLowerCase()) : false;
                const financeStatusMatch = financeStatusFilter ? item.account_status === financeStatusFilter : true;
        
                // Date range matching logic
                const itemAccountApprovedDate = new Date(item.account_approved_date);
                const matchesDateRange = (
                    (!startDate || itemAccountApprovedDate >= new Date(startDate).setHours(0, 0, 0, 0)) &&
                    (!endDate || itemAccountApprovedDate <= new Date(endDate).setHours(23, 59, 59, 999))
                );
        
                // Filter based on URL path
                if (location.pathname === '/finance_fuel_reports/all') {
                    return codeMatch && financeStatusMatch && matchesDateRange; // Show all matching items
                } else if (location.pathname === '/finance_fuel_reports/pending') {
                    return item.audit_status === 'Pending' && codeMatch && matchesDateRange; // Show only pending items
                } else if (location.pathname === '/finance_fuel_reports/approved') {
                    return item.audit_status === 'Approved' && codeMatch && matchesDateRange; // Show only approved items
                } else if (location.pathname === '/finance_fuel_reports/rejected') {
                    return item.audit_status === 'Rejected' && codeMatch && matchesDateRange; // Show only rejected items
                } else if (location.pathname === "/finance_fuel_reports") {
                    return codeMatch && financeStatusMatch && matchesDateRange; // Default case
                }
                return false; // Default case
            });
        
            const sorted = filtered.sort((a, b) => {
                if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
                if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
                return 0;
            });
        
            setFilteredItems(sorted);
            setCurrentPage(1); // Reset to first page when items or search query changes
        }, [searchQuery, items, sortColumn, sortOrder, financeStatusFilter, location.pathname, startDate, endDate]);

        


    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = e => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = pageNumber => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = e => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const exportToExcel = () => {
            // Use filteredItems to export all the data based on current filtering, not just the visible ones in pagination
            const filteredBranchNames = filteredItems.map(item => ({
                CompleteName: item.comp_name,
                Employeecode: item.emp_code,
                Transcode: item.trans_code,
                ReportingManager: item.report_mngr,
                TotalKm: item.total_fuel_qty,
                TotalAmount: Math.trunc(item.total_fuel_amt),
                FixedAmount: Math.trunc(item.total_fixed),
                AuditApprovedAmount: Math.trunc(item.audit_approved_amount),
                FinanceApprovedDate: item.account_approved_date,
                ReportingManagerStatus: item.rpt_mgr_status,
                AuditStatus: item.audit_status,
                FinanceStatus: item.account_status,
    
            }));
    
            const worksheet = XLSX.utils.json_to_sheet(filteredBranchNames);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Conveyance');
            XLSX.writeFile(workbook, 'Fuel_Form_Details.xlsx');
        };

    

  


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Fuel Forms List</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><Link to="/dashboard">Home</Link></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Fuel Forms List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                    <div className="card-header">
                                            <span style={{ float: 'right' }}>
                                                
                                                <button type="button" className="btn btn-secondary ml-2" onClick={exportToExcel}>
                                                    Export to Excel
                                                </button>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            {isLoading ? (
                                                <p>Loading...</p>
                                            ) : fuelFormList.length === 0 ? (
                                                <p>No fuel forms found.</p>
                                            ) : (
                                                <>
                                                  <div id="example1_filter" style={{ float: 'right' }} className="dataTables_filter">
                                                        <label>
                                                            <input
                                                                type="search"
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Search"
                                                                aria-controls="example1"
                                                            />
                                                        </label>
                                                    </div>

                                                    <div className="form-group" style={{ display: 'inline-block', marginRight: '15px' }}>
                                                        <select
                                                            className="form-control custom-select-sm"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>

                                                    <div className="row" style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                                                                                                            <div className="col-md-5">
                                                                                                                <div className="form-group">
                                                                                                                    <DatePicker
                                                                                                                        selected={startDate}
                                                                                                                        onChange={(date) => setStartDate(date)}
                                                                                                                        selectsStart
                                                                                                                        startDate={startDate}
                                                                                                                        endDate={endDate}
                                                                                                                        dateFormat="yyyy-MM-dd"
                                                                                                                        className="form-control"
                                                                                                                        placeholderText="Select Start Date"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                    
                                                                                                            <div className="col-md-5">
                                                                                                                <div className="form-group">
                                                                                                                    <DatePicker
                                                                                                                        selected={endDate}
                                                                                                                        onChange={(date) => setEndDate(date)}
                                                                                                                        selectsEnd
                                                                                                                        startDate={startDate}
                                                                                                                        endDate={endDate}
                                                                                                                        minDate={startDate}
                                                                                                                        dateFormat="yyyy-MM-dd"
                                                                                                                        className="form-control"
                                                                                                                        placeholderText="Select End Date"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>

                                                    <div className="table-responsive">

                                                   
                                                    <table className="table table-hover text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Driver</th>
                                                                <th>Driver Name</th>
                                                                <th>Grade</th>
                                                                <th>Submit Status</th>
                                                                <th>Total Fuel Qty</th>
                                                                <th>Total Amount</th>
                                                                <th>Fixed Amount</th>
                                                                <th>Audit Approved Amount</th>
                                                                <th>Rpt Mgr Status</th>
                                                                <th>Report Manager</th>
                                                                <th>
                                                                    created-at
                                                                </th>
                                                                <th>Audit Status</th>
                                                                <th>Audit Approved Date</th>
                                                                <th>Account Status</th>
                                                                <th>Account Approved Date</th>
                                                               
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {currentItems.length > 0 ? (
                                                                currentItems.map((fuelForm, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {index +
                                                                                1 +
                                                                                (currentPage - 1) * itemsPerPage}
                                                                        </td>
                                                                        <td>{fuelForm.emp_code}</td>
                                                                        <td>{fuelForm.comp_name}</td>
                                                                        <td>{fuelForm.grade}</td>
                                                                        <td>{fuelForm.isSubmited}</td>
                                                                        <td>{fuelForm.total_fuel_qty}</td>
                                                                        <td>{fuelForm.total_fuel_amt}</td>
                                                                        <td>{fuelForm.total_fixed}</td>
                                                                        <td>{Math.trunc(fuelForm.audit_approved_amount)}</td>
                                                                        <td style={{ color: fuelForm.rpt_mgr_status === 'Pending' ? 'orange' : fuelForm.rpt_mgr_status === 'Rejected' ? 'red' : fuelForm.rpt_mgr_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                    {fuelForm.rpt_mgr_status}
                                                                                </td>
                                                                                <td>{fuelForm.report_mngr}</td>
                                                                                
                                                                                <td>
                                                                                {new Date(fuelForm.createdDTM)
                                                                                    .toLocaleDateString("en-GB")
                                                                                    .replace(/\//g, "-")}
                                                                            </td>  
                                                                                <td style={{ color: fuelForm.audit_status === 'Pending' ? 'orange' : fuelForm.audit_status === 'Rejected' ? 'red' : fuelForm.audit_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                    {fuelForm.audit_status}
                                                                                </td> 
                                                                                
                                                                                <td>
                                                                                {new Date(fuelForm.audit_approved_date)
                                                                                    .toLocaleDateString("en-GB")
                                                                                    .replace(/\//g, "-")}
                                                                            </td>  
                                                                                <td style={{ color: fuelForm.account_status === 'Pending' ? 'orange' : fuelForm.account_status === 'Rejected' ? 'red' : fuelForm.account_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                    {fuelForm.account_status}
                                                                                </td>  
                                                                                
                                                                                <td>
                                                                                {new Date(fuelForm.account_approved_date)
                                                                                    .toLocaleDateString("en-GB")
                                                                                    .replace(/\//g, "-")}
                                                                            </td>           
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan='3'>No data available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                    </div>
                                                    {/* <nav>
                                                        
                                                    </nav>
                                                    <div className='mb-3'>
                                                        Showing {startItem} to {endItem} of {filteredItems.length}{" "}
                                                        entries
                                                    </div> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        handlePageChange={handlePageChange}
                                    />
                                    <div className="mb-3">
                                        Showing {startItem} to {endItem} of {filteredItems.length} entries
                                    </div>
                                </section>
                            </div>
                        </div>

                    </section>
                </div >
                <Footer />
            </div >
        </div >


    )
}

export default Finance_Fuel_Reports